module.exports = require("./dist/tools.js")